import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { Button } from '@repo/ui/button';
import { Link } from 'react-router';

export const ResetPasswordPage = () => {
  useLocale();

  return (
    <div className="w-screen max-w-lg px-4">
      <div className="w-full">
        <h1 className="font-semibold text-3xl">{t('auth.unableToResetPassword')}</h1>
        <p className="mt-2 text-muted-foreground text-sm">
          {t('auth.theTokenYouHaveUsedToResetYourPassword')}{' '}
        </p>
        <Button asChild className="mt-4">
          <Link to="/signin">{t('auth.returnToSignIn')}</Link>
        </Button>
      </div>
    </div>
  );
};
